module.exports = __webpack_public_path__ + "img/shizi.d463edf1.d463edf1.jpg";